<script setup>
const route = useRoute()
useCustomMeta('pref', getAreaPrefectureName(route.params.pref))
const breadCrumbList = getBreadCrumb(route.params.area, route.params.pref)
const { data: mapPosition } = await useFetch('/api/wind/mapConfig', { query: { path: route.params.pref } })
const areaEntry = areaToPrefTable.find((item) => item.key === route.params.area)
if (!areaEntry || !areaEntry.pref_list.some((pref) => pref.key === route.params.pref)) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Invalid Path'
  })
}
</script>

<template>
  <div>
    <NuxtLayout
      name="custom"
      :bread-crumb-list="breadCrumbList"
      :pref="getAreaPrefectureName(route.params.pref)"
      :pref-roma="route.params.pref"
    >
      <div class="frame">
        <WindMap
          :map-position="mapPosition"
          :title="getAreaPrefectureName(route.params.pref)"
          :pref-en="route.params.pref"
        />
      </div>
      <template #main-bottom>
        <WindCityList :pref="route.params.pref" />
      </template>
    </NuxtLayout>
  </div>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.ads-btf1-sp {
  min-height: 50px;
  text-align: center;
  margin: 0px auto;
  position: relative;
}
</style>
